import { render, staticRenderFns } from "./ActiveTaxiTableRows.vue?vue&type=template&id=c0a339ba&"
import script from "./ActiveTaxiTableRows.vue?vue&type=script&lang=js&"
export * from "./ActiveTaxiTableRows.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTaxiTableRows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports